import { TASK_STATUS } from '~/enums'

export function Status2Text(status, error, t) {
  switch (status) {
    case TASK_STATUS.NEW:
      return `${t('COMMON_STATUS_TEXT_OPERATION_IS_QUEUED')}...`
    case TASK_STATUS.PREPARE_IMAGES:
      return `${t('COMMON_STATUS_TEXT_PREPARE_IMAGES')}...`
    case TASK_STATUS.RUNNING:
      return `${t('COMMON_STATUS_TEXT_RENDERING')}...`
    case TASK_STATUS.DOWNLOADING:
      return `${t('COMMON_STATUS_TEXT_DOWNLOADING_MEDIA_FILES')}...`
    case TASK_STATUS.UPLOADING:
      return `${t('COMMON_STATUS_TEXT_UPLOADING_SAVED_MEDIA')}...`
    case TASK_STATUS.ABORTED:
      return `${t('COMMON_STATUS_TEXT_ABORTED')}: ${error}`
    case TASK_STATUS.CONVERT:
      return `${t('COMMON_STATUS_TEXT_CONVERT')}...`
    default:
      return ''
  }
}
